import React from 'react';
import {
  CurrencyDollarIcon,
  ChartBarIcon,
  InformationCircleIcon,
  SwitchHorizontalIcon,
  ClipboardListIcon,
} from '@heroicons/react/outline';

import SidebarItemParent from './SidebarItemParent';
import SidebarItem from './SidebarItem';

import StorageService from 'utils/storage';
import { ISidebarParent } from './interfaces';

// '10', '11', '20', '21', '22'
const SIDEBAR_ITEMS: Array<ISidebarParent> = [
  {
    title: 'Operaciones',
    name: 'operations',
    icon: SwitchHorizontalIcon,
    levels: ['10', '21'],
    items: [
      { title: 'Clientes', name: 'customers', path: '/customers', levels: ['10'] },
      { title: 'Operaciones', name: 'operations', path: '/operations', levels: ['10', '20', '21'] },
      { title: 'Hitorial', name: 'history', path: '/history', levels: ['20', '21'] },
      { title: 'Firmados', name: 'signed', path: '/signed', levels: ['10'] },
      { title: 'Comprobantes', name: 'vouchers', path: '/vouchers', levels: ['10'] },
    ],
  },
  {
    title: 'Precios',
    name: 'prices',
    icon: CurrencyDollarIcon,
    levels: ['10', '21'],
    items: [
      { title: 'Precios y tasas', name: 'change', path: '/change', levels: ['10', '20', '21'] },
      { title: 'Tarifas especiales', name: 'ranges', path: '/ranges', levels: ['10'] },
    ],
  },
  {
    title: 'Gestión',
    name: 'management',
    icon: ClipboardListIcon,
    levels: ['10'],
    items: [
      { title: 'Bancos', name: 'banks', path: '/banks', levels: ['10'] },
      { title: 'Series', name: 'series', path: '/series', levels: ['10'] },
      { title: 'Operadores', name: 'operators', path: '/operators', levels: ['10'] },
    ],
  },
  {
    title: 'Reportes',
    name: 'reports',
    icon: ChartBarIcon,
    levels: ['10', '22'],
    items: [
      { title: 'Reporte de operaciones', name: 'reports', path: '/reports', levels: ['10', '22'] },
      { title: 'Gráficos', name: 'graphs', path: '/graphs', levels: ['10'] },
      { title: 'Reclamos', name: 'claims', path: '/claims', levels: ['10'] },
    ],
  },
  {
    title: 'Información',
    name: 'info',
    icon: InformationCircleIcon,
    levels: ['10', '11'],
    items: [
      { title: 'Promociones', name: 'promos', path: '/promos', levels: ['10'] },
      // { title: 'Correo masivo', name: 'mail', path: '/mailer', levels: ['10'] },
      { title: 'Landing', name: 'landing', path: '/landing', levels: ['10', '11'] },
    ],
  },
];

export default function SidebarItems({
  className,
  onCloseClick,
}: {
  className?: string;
  onCloseClick?: () => void;
}) {
  const level = StorageService.get('userData', 'admin')?.level;
  const sidebarItems = SIDEBAR_ITEMS.filter((obj) => obj.levels.includes(level)).map((obj) => ({
    ...obj,
    items: obj.items.filter((item) => item.levels.includes(level)),
  }));

  return (
    <nav className={className}>
      {sidebarItems.map((obj) => {
        if (obj.items !== undefined && obj.items.length > 1) {
          return (
            <SidebarItemParent
              key={obj.name}
              sidebarItem={obj}
              paths={obj.items.map((item) => item.path)}
            >
              {obj.items.map((item, index) => {
                return (
                  <SidebarItem
                    key={item.name}
                    index={index}
                    max={obj.items.length - 1}
                    path={item.path}
                    onClick={onCloseClick}
                    isChild={true}
                  >
                    {item.title}
                  </SidebarItem>
                );
              })}
            </SidebarItemParent>
          );
        }
        if (!sidebarItems.some((obj2) => obj2.name === obj.name)) return null;
        return (
          <SidebarItem
            key={obj.items[0]?.name}
            index={1}
            max={2}
            path={obj.items[0]?.path}
            onClick={onCloseClick}
            isChild={false}
          >
            <>
              {obj.icon}
              {obj.items[0]?.title}
            </>
          </SidebarItem>
        );
      })}
    </nav>
  );
}
